import * as actionTypes from './actionTypes';
import { LIST } from '../constants/views';
import { sortLevelsBySpent } from '../../helpers';

// Init state
export const mainState = {
  view: LIST,
  init: false,
  isLoadingList: true,
  error: null,
  default_language_code: null,
  default_levels: [],
  edit_level_index: null,
  levels: [],
  languages: [],
};

export const stateReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.LIST:
    return {
      ...state,
      error: null,
      isLoadingList: true,
    };
  case actionTypes.LIST_SUCCESS:
    return {
      ...state,
      init: true,
      isLoadingList: false,
      levels: payload.levels,
      default_levels: payload.levels,
      languages: payload.languages,
      default_language_code: payload.defaultLanguageCode,
    };
  case actionTypes.LIST_ERROR:
    return {
      ...state,
      isLoadingList: false,
      error: payload.levels,
    };
  case actionTypes.CHANGE_VIEW:
    return {
      ...state,
      view: payload.view,
      edit_level_index: null,
    };
  case actionTypes.EDIT_LEVEL:
    return {
      ...state,
      view: payload.view,
      edit_level_index: payload.index,
    };
  case actionTypes.EDIT_LEVEL_SUCCESS:
    return {
      ...state,
      view: LIST,
      edit_level_index: null,
      levels: state.levels.map((level, index) => {
        if (index === state.edit_level_index) {
          return {
            ...level,
            name: payload.name,
            discount: payload.discount,
            total_spent: payload.total_spent,
          }
        }
        return {
          ...level,
        }
      }).sort(sortLevelsBySpent),
    };
  case actionTypes.ADD_LEVEL_SUCCESS:
    return {
      ...state,
      view: LIST,
      edit_level_index: null,
      levels: [...state.levels, {
        id: null,
        name: payload.name,
        discount: payload.discount,
        total_spent: payload.total_spent,
      }].sort(sortLevelsBySpent),
    };
  case actionTypes.DELETE_LEVEL:
    return {
      ...state,
      view: LIST,
      edit_level_index: null,
      levels: state.levels.filter((level, index) => index !== state.edit_level_index),
    };
  default:
    throw new Error();
  }
};
